import React from "react";
import { SideMenu, BackHeader, Model } from "./../../components";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import ProfileImg from "./../../../assets/images/profileImage.jpg";
import { Button } from "@mui/material";
import { FileUploader } from "react-drag-drop-files";
import { FiChevronRight } from "react-icons/fi";
import Checkbox from "@mui/material/Checkbox";
import { useAlert } from "react-alert";
import Countries from "./../../../data/countries";
import { useNavigate, useLocation } from "react-router-dom";
const label = { inputProps: { "aria-label": "Checkbox demo" } };
const fileTypes = ["JPEG", "PNG", "GIF"];
const OnlineClassCreate = () => {
  const alert = useAlert();
  const navigate = useNavigate();
  const location = useLocation();
  const [file, setFile] = React.useState(null);
  const handleChange = (file) => {
    setFile(file);
  };
  const [addStudents, setAddStudents] = React.useState(false);
  const AddStudentList = [
    {
      name: "Samantha aryton",
    },
    {
      name: "Johan smith",
    },
    {
      name: "Nataliya law",
    },
    {
      name: "Jezing",
    },
    {
      name: "Samantha aryton",
    },
  ];
  const State = [
    {
      title: "Balochistan",
    },
    {
      title: "Punjab",
    },
    {
      title: "Sindh",
    },
    {
      title: "KPK",
    },
  ];
  // Add Students
  const [addStudentsLoading, setAddStudentsLoading] = React.useState(false);
  const AddStudentsHanlder = () => {
    setAddStudentsLoading(true);
    alert.success(
      <div className="alert-message">you have successfully add students</div>
    );
    setTimeout(() => {
      setAddStudents(false);
      setAddStudentsLoading(false);
    }, 2000);
  };
  return (
    <SideMenu>
      <div className="page-details-container">
        <BackHeader backHanler={() => navigate(-1)} />
        <p className="page-form-heading">
          {location.state.type === "Create"
            ? "Create class / Workshop"
            : "Edit class / Workshop"}
        </p>
        <Box sx={{ flexGrow: 1 }}>
          <Grid container spacing={2}>
            <Grid item xl={6} lg={6} md={12} sm={12} xs={12}>
              <FileUploader
                multiple={true}
                handleChange={handleChange}
                name="file"
                types={fileTypes}
                color="red"
              />
              <p className="drop-file-heading">
                upload your Class / Workshop thumbnail
              </p>
            </Grid>
            <Grid item xl={6} lg={6} md={12} sm={12} xs={12}></Grid>
            <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
              <div>
                <p className="input-heading">Course title</p>
                <input
                  type="text"
                  className="input"
                  placeholder="Enter course title"
                />
              </div>
            </Grid>

            <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
              <p className="input-heading">Course Description</p>
              <textarea
                className="textarea"
                placeholder="Enter your course descriptions"
                rows="20"
                cols="40"
              ></textarea>
            </Grid>
            <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
              <div>
                <p className="input-heading">Teacher Name</p>
                <input type="text" className="input" placeholder="Enter name" />
              </div>
            </Grid>
            <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
              <div>
                <p className="input-heading">Topic</p>
                <input
                  type="text"
                  className="input"
                  placeholder="Enter topic"
                />
              </div>
            </Grid>
            <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
              <div>
                <p className="input-heading">Add students</p>
                <Button
                  className="add-students-button"
                  variant="text"
                  onClick={() => setAddStudents(true)}
                >
                  Select...
                  <FiChevronRight />
                </Button>
              </div>
            </Grid>
            <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
            <div>
              <p className="input-heading">Country</p>
              <select className="input">
                <option value="">Select</option>
                {Countries.map((countriesValue, countriesIndex) => {
                  return (
                    <option key={countriesIndex} value={countriesValue.name}>
                      {countriesValue.name}
                    </option>
                  );
                })}
              </select>
            </div>
          </Grid>
          <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
            <div>
              <p className="input-heading">State</p>
              <select className="input">
                <option value="">Select</option>
                {State.map((stateValue, stateIndex) => {
                  return (
                    <option key={stateIndex} value={stateValue.title}>
                      {stateValue.title}
                    </option>
                  );
                })}
              </select>
            </div>
            </Grid>
            <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
              <div>
                <p className="input-heading">Start date</p>
                <input type="date" className="input" placeholder="Start date" />
              </div>
            </Grid>
            <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
              <div>
                <p className="input-heading">Start Time</p>
                <input type="time" className="input" placeholder="Start Time" />
              </div>
            </Grid>
            <Grid item xl={3} lg={3} md={3} sm={12} xs={12}></Grid>
            <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
              <Button
                className="form-button"
                variant="text"
                onClick={() => navigate(-1)}
              >
                {location.state.type === "Create"
                  ? " Create class"
                  : " Update class"}
              </Button>
            </Grid>
            <Grid item xl={3} lg={3} md={3} sm={12} xs={12}></Grid>
          </Grid>
        </Box>
      </div>
      <Model
        modelTitle="Add students"
        width="md"
        onClose={() => setAddStudents(false)}
        open={addStudents}
        buttonTitle="ADD"
        buttonHandler={AddStudentsHanlder}
        loading={addStudentsLoading}
      >
        <div className="form-container">
          {AddStudentList.map((addStudentsValue, setAddStudentsIndex) => {
            return (
              <div className="add-student-model-list" key={setAddStudentsIndex}>
                <div className="add-student-model-list-profile-main">
                  <img
                    src={ProfileImg}
                    className="add-student-model-list-profile-image"
                  />
                  <p className="add-student-model-list-username">
                    {addStudentsValue.name}
                  </p>
                </div>
                <Checkbox
                  {...label}
                  defaultChecked
                  sx={{ "& .MuiSvgIcon-root": { fontSize: 28 } }}
                />
              </div>
            );
          })}
        </div>
      </Model>
    </SideMenu>
  );
};
export default OnlineClassCreate;
